import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { ColumnBlockType } from '@appTypes/ColumnBlockType';
import { VerticallyFadingSectionBlocks } from '.';
import { LinkField } from './blocks/LatestArticleBlock';
import {
  ColumnBlockHeader,
  ColumnBlockWrapper,
  ColumnContainer,
  ColumnWrapper,
  IngressText,
} from './ColumnBlock.styles';

type Props = {
  block: ColumnBlockType;
  activateContextThemeSwitch?: boolean;
  headerVariant?: 'large' | 'small';
};

export const ColumnBlock: React.FC<Props> = ({ block, activateContextThemeSwitch, headerVariant = 'small' }) => {
  const { columnArray, title, link, ingress } = block;
  return (
    <ColumnBlockWrapper>
      <ColumnBlockHeader $headerVariant={headerVariant}>
        <Text variant={headerVariant === 'large' ? TextVariant.Header1 : TextVariant.Header2} tag="h2">
          {title}
        </Text>
        <LinkField link={link} />
      </ColumnBlockHeader>
      {ingress && (
        <IngressText tag="p" variant={TextVariant.ArticleText}>
          {ingress}
        </IngressText>
      )}
      <ColumnWrapper>
        {columnArray.map(({ columnContent, key }) => (
          <ColumnContainer key={key}>
            <VerticallyFadingSectionBlocks
              content={columnContent}
              activateContextThemeSwitch={activateContextThemeSwitch}
            />
          </ColumnContainer>
        ))}
      </ColumnWrapper>
    </ColumnBlockWrapper>
  );
};
